module.exports = __webpack_public_path__ + "static/homepage-1-9d8a5ec7c9514aea89827c437f980fb9.png";